import { api } from 'api'
import moment from 'moment/moment'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { DATE_FORMAT } from 'shared/utils/dateFormatting'
import { ReportValues } from '../ReportsMutate'
import { toaster } from 'uikit/Toaster'

const dateFormat = 'YYYY-MM-DD'

export const useSendPaymentsRegistry = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ date, type }: ReportValues) => {
      const momentFrom = moment(date?.from, DATE_FORMAT)
      const momentTo = moment(date?.to, DATE_FORMAT)

      const body = {
        from: date ? momentFrom.format(dateFormat) : undefined,
        to: date ? momentTo.format(dateFormat) : undefined,
        type,
      }

      return api.payments.createReport(body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reportsList'] })

      toaster.create({
        title: 'Заявка отправлена успешно',
      })
    },
    onError: (err: any) => {
      toaster.create({
        title: 'Произошла ошибка при попытке отправить заявку',
        description: err.response?.data?.message || err.message,
      })
    },
  })
}
